import { makeAutoObservable } from 'mobx'
import { Player } from '@/services/types/player'

export const getEnv = () => {
  console.log('getEnv', process.env.PUBLIC_URL)
  if (process.env.PUBLIC_URL === '/cmcc') {
    return 'CMCC'
  } else if (process.env.PUBLIC_URL === '/r1-app-h5') {
    return 'APP'
  } else {
    return 'H5'
  }
}

export const DefautlUser = {
  playerId: '',
  avatarUrl: '',
  name: '',
  faceId: '',
  phoneNumber: '',
}
export class User {
  private _phoneNumber: string = ''
  private _from: 'CMCC' | 'APP' | 'H5' | string = getEnv()
  private _token: string = ''
  private _uid: string = ''
  private _gameSel: string = '2' // 棋力闯关
  private _userPlayer: Player = DefautlUser
  private _curPlayer: Player = DefautlUser

  constructor() {
    makeAutoObservable(this)
  }

  set phoneNumber(value: string) {
    this._phoneNumber = value
  }
  get phoneNumber() {
    return this._phoneNumber
  }
  set from(value: string) {
    this._from = value
  }
  get from() {
    return this._from
  }
  set token(value: string) {
    this._token = value
  }
  get token() {
    return this._token
  }
  set uid(value: string) {
    this._uid = value
  }
  get uid() {
    return this._uid
  }
  set userPlayer(value: Player) {
    this._userPlayer = value
  }
  get userPlayer() {
    return this._userPlayer
  }
  set curPlayer(value: Player) {
    this._curPlayer = value
  }
  get curPlayer() {
    return this._curPlayer
  }

  set gameSel(value: string) {
    this._gameSel = value
  }
  get gameSel() {
    return this._gameSel
  }

  reset() {
    this.userPlayer = DefautlUser
    this.curPlayer = DefautlUser
  }
}

export default new User()
